import React from 'react';

const RippleAnimation: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <>
    <div className="ripple-container">
      <div className="ripple-child">{children}</div>
      <div className="ripple-animation">
        <div className="ripple-item1" />
        <div className="ripple-item2" />
        <div className="ripple-item3" />
      </div>
    </div>

    {/* styles are the same as in Option 1; you can keep them in a global CSS file */}
    <style>{cssRipple}</style>
  </>
);

const cssRipple = `
.ripple-container{
  position: relative;

}

.ripple-child{
  z-index: 2;
  position: relative;
}

.ripple-animation {
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > div {
    animation: ripple 2.5s infinite ease-out;
    transform: scale(0.65);
    background-color: #3EA72D;
    border-radius: 50%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }

  .ripple-item1 { animation-delay: 0s }
  .ripple-item2 { animation-delay: .8s }
  .ripple-item3 { animation-delay: 1.6s }
}

@keyframes ripple {
  0%   { transform: scale(0.65); opacity: .45; }
  70%  { opacity: 0; }
  100% { transform: scale(1.35); opacity: 0; }
}

@keyframes rippleInvert {
  0%  { transform: scale(1); opacity: .35; }
  30%  { opacity: .35 }
  100% { transform: 'scale(0); opacity: 0 }
}


`;

export default RippleAnimation;
